import React, { useEffect, useMemo, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "./Selectedexercise.css";
import { ip_back } from "../config";
import { pickFirstNotStartedExerciseIndex } from "../utils/coachExerciseNavigation";
import { currentAppLanguage } from "../utils/appLanguages";
import { localizedSubTypeName } from "../utils/localizedCatalogFields";

const ExerciseSlider = ({
  seteximg,
  exercises,
  setselectedex,
  hideArrows = false,
  selectedExerciseId = null,
  exerciseStates = {},
}) => {
  const currentlng = currentAppLanguage();
  const isControlled =
    selectedExerciseId != null && String(selectedExerciseId) !== "";

  const validExercises = useMemo(
    () =>
      Array.isArray(exercises)
        ? exercises.filter((ex) => ex && ex !== null && ex !== undefined)
        : [],
    [exercises]
  );

  const exerciseIdsKey = useMemo(
    () => validExercises.map((ex) => ex?.te_id).join("|"),
    [validExercises]
  );

  const parentIndex = useMemo(() => {
    if (!validExercises.length) return 0;
    if (isControlled) {
      const found = validExercises.findIndex(
        (ex) => ex?.te_id && String(ex.te_id) === String(selectedExerciseId)
      );
      return found >= 0 ? found : 0;
    }
    return pickFirstNotStartedExerciseIndex(validExercises, exerciseStates);
  }, [exerciseIdsKey, isControlled, selectedExerciseId, exerciseStates, validExercises]);

  /** Only used when arrows are visible (uncontrolled navigation). */
  const [localIndex, setLocalIndex] = useState(null);

  useEffect(() => {
    setLocalIndex(null);
  }, [selectedExerciseId, exerciseIdsKey]);

  const activeIndex = hideArrows || isControlled ? parentIndex : localIndex ?? parentIndex;
  const currentExercise = validExercises[activeIndex] || null;

  useEffect(() => {
    if (!currentExercise?.sub_type_ex?.sub_type_image_normal) return;
    seteximg(
      `${ip_back + currentExercise.sub_type_ex.sub_type_image_normal}`
    );
  }, [currentExercise?.te_id, currentExercise?.sub_type_ex?.sub_type_image_normal, seteximg]);

  // Uncontrolled only: push selection to parent (never fight TableSetup when controlled).
  useEffect(() => {
    if (isControlled || hideArrows || !currentExercise?.te_id) return;
    setselectedex(currentExercise);
  }, [isControlled, hideArrows, currentExercise?.te_id, setselectedex, currentExercise]);

  const handleNext = () => {
    setLocalIndex((prev) => {
      const base = prev ?? parentIndex;
      const next = base < validExercises.length - 1 ? base + 1 : 0;
      const ex = validExercises[next];
      if (ex) setselectedex(ex);
      return next;
    });
  };

  const handlePrev = () => {
    setLocalIndex((prev) => {
      const base = prev ?? parentIndex;
      const next = base > 0 ? base - 1 : validExercises.length - 1;
      const ex = validExercises[next];
      if (ex) setselectedex(ex);
      return next;
    });
  };

  if (validExercises.length === 0 || !currentExercise) {
    return null;
  }

  if (hideArrows && !currentExercise?.sub_type_ex?.sub_type_image_normal) {
    return null;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <div className="table_ex_list">
        {!hideArrows && (
          <div className="table_ex_arrow">
            <ArrowBackIosIcon
              onClick={handlePrev}
              style={{ marginLeft: "7px" }}
            />
          </div>
        )}
        <div className="table_ex_name">
          {currentExercise?.sub_type_ex?.sub_type_image_normal && (
            <div className="selected-ex-add">
              <img
                src={
                  ip_back + currentExercise?.sub_type_ex?.sub_type_image_normal
                }
                alt={localizedSubTypeName(currentExercise?.sub_type_ex, currentlng)}
              />
            </div>
          )}
          {!hideArrows && (
            <p>
              {activeIndex + 1}.
              {localizedSubTypeName(currentExercise?.sub_type_ex, currentlng)}
            </p>
          )}
        </div>
        {!hideArrows && (
          <div className="table_ex_arrow">
            <ArrowForwardIosIcon
              onClick={handleNext}
              style={{ marginLeft: "7px" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseSlider;
